import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, message, Select, Spin, Table } from 'antd';
import "./index.css";
import { domain } from '../interface';
import { max } from "lodash";
const { Option } = Select;
/**
 * 选择客户页
 */
let selectedCustomer = {}
const SelectCustomerPage = () => {
    let navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([])
    // const [selectCustomer, setSelectCustomer] = useState()
    const [businessData, setBusinessData] = useState([])
    const [contactData, setContactData] = useState([])
    const [productData, setProductData] = useState([])
    const [value, setValue] = useState()
    let lastFetchId = 0
    const columns = [
        {
            title: '商机名称',
            dataIndex: 'name',
            render: text => <a>{text}</a>,
        },
        {
            title: '产品',
            dataIndex: 'product_name',
        },
        {
            title: '盈率',
            dataIndex: 'probability',
            render: (value) => <div>{`${value}%`}</div>
        },
       
    ];

    /**
     * 电话号脱敏
     * @param {*} phone 
     * @returns 
     */
    const getShowPhone = (phone) => {
        const start = phone.substring(0, 3)
        const end = phone.substring(phone.length - 4)
        return `${start}****${end}`
    }

    const contactColumns = [
        {
            title: '姓名',
            dataIndex: 'name',
            render: text => <a>{text}</a>,
        },
        Table.EXPAND_COLUMN,

        // {
        //     title: '手机',
        //     dataIndex: 'mobile1',
        //     render: (text) => <div>{getShowPhone(text + '')}</div>
        // },
        // {
        //     title: '邮箱',
        //     dataIndex: 'email',
        // },
        {
            title: '多 选 产 品',
            maxWidth: 200,
            render: (item) =>
                <Select style={{ width: '100%',maxWidth:'200px' }}  mode="multiple" onChange={(value) => handleContactChange(value, item)}>
                    {productData && productData.map(item => {
                        return <Option key={item} value={item}>{item}</Option>
                    })}
                </Select>
        },
    ]

    /**
     * 获取客户列表
     * @param {*} value 
     * @returns 
     */
    const fetchUser = (value) => {
        if (value.length < 2) {
            return
        }
        lastFetchId += 1;
        const fetchId = lastFetchId;
        setLoading(true)
        let userName = localStorage.getItem("userName")
        fetch(`${domain}/sale/customer`, { method: 'POST', body: JSON.stringify({ name: value,userName:userName }) })
            .then(response => response.json())
            .then(body => {
                if (fetchId !== lastFetchId) {
                    return;
                }
                const data = body.data
                setData(data)
                setLoading(false)
            })
            .finally(() => {
                setLoading(false)
            });
    };

    /**
     * 搜索商机列表和用户列表
     */
    const fetchBusiness = (id) => {
        fetch(`${domain}/sale/relaandopp`, { method: 'POST', body: JSON.stringify({ _id: id }) })
            .then(response => response.json())
            .then(body => {
                const data = body.data
                const userData = data.contractor
                const oppData = data.opp
                let resultData = []
                if (userData) {
                    userData.map(item => {
                        let info = {
                            key: item._id,
                            name: item.name,
                            mobile1: item.mobile1,
                            email: item.email,
                            selectOpp: [],
                        }
                        resultData.push(info)
                    })
                }
                let productArray = []
                if(oppData){
                    oppData.map(item => {
                        productArray.push(item.product_name)
                    })
                }
                setProductData([... new Set(productArray)])
                setBusinessData(oppData)
                if (oppData.length<=0){
                    message.info('选择的客户没有赢率25以上的商机！')
                }    
    
                setContactData(resultData)
            })
            .finally(() => {
                setLoading(false)
            });
    }

    const handleCustomerChange = value => {
        setValue(value)
        setLoading(false)

        // console.log(data,value)
        data.map(item => {
            if (item._id === value.value) {
                selectedCustomer = {...item}
            }
        })
        setData([])
        // console.log("selectedCustomer-1:",selectedCustomer)
        // console.log(value)

        if (value) {
            fetchBusiness(value ? value.value : '')    
        } else {
            setBusinessData([])
            setContactData([])
            setProductData([])
        }
    };

    const handleContactChange = (value, item) => {
        // console.log(value)
        // console.log(item)
        const index = contactData.findIndex(info => info.key == item.key)
        // console.log(index)
        if (index > -1) {
            contactData[index].selectOpp = value
            setContactData(contactData)
        }
    };

    const clickNext = () => {
        if (value) {
            let selectUsers = []
            contactData.map(item => {
                if(item.selectOpp.length>0){
                    selectUsers.push(item)
                }
            })
            // console.log("selectUsers:",selectUsers)
            // 只展示选择的商机
            let selectedProds = []
            selectUsers.map(item => {
                item.selectOpp.map(prod => {
                    if(!selectedProds.includes(prod)){
                        selectedProds.push(prod)
                    }
                })
            })

             let selectedBussiness = []
            businessData.map(item => {
                if(selectedProds.includes(item.product_name)){
                    selectedBussiness.push(item)
                }
            })   
            // console.log("selectUsers:",selectUsers)
            if (selectUsers.length<=0){
                message.info('请选择开通账号的客户和产品！')
                return
            }
            navigate("/applyAccount", { state: { selectedCustomer,customerName: value.label, selectUsers, selectedBussiness } });
        } else {
            message.info('请选择客户')
        }
    }
    return (
        <>
            <div className="container">
                <div className="content">
                    <Select
                        showSearch
                        showArrow={false}
                        labelInValue
                        value={value}
                        placeholder="输入选择客户"
                        notFoundContent={loading ? <Spin size="small" /> : null}
                        filterOption={false}
                        onSearch={fetchUser}
                        onChange={handleCustomerChange}
                        style={{ width: '100%' }}
                    >
                        {data && data.map(item => (
                            <Option key={item._id}>{item.name}</Option>
                        ))}
                    </Select>

                    <div className="table_title">选择客户及开通产品</div>
                    <Table className="table_container" 
                        pagination={false} 
                        scroll={{ x: 'max-content' }}
                        columns={contactColumns}
                        expandable={{
                            expandedRowRender: (record) => (
                              <p
                                style={{
                                  margin: 0,
                                }}
                              >
                                手机：{getShowPhone(record.mobile1)}；Email:{record.email}
                              </p>
                            ),
                          }}                         
                        dataSource={contactData}
                     />

                    <div className="table_title">对应商机（25%以上）</div>
                    <Table className="table_container" 
                        columns={columns} 
                        pagination={false} 
                        // scroll={{ y: 240 }}
                        dataSource={businessData} 
                    />
                    <div style={{ marginTop: '20px' }}>
                        <Button className="next_button" type="primary" onClick={clickNext}>下一步</Button>
                    </div>
                </div>
            </div>
        </>
    )
}
export default SelectCustomerPage